import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./css/variables.css";
import "./App.css"
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';

import api from "./api";
import { initGlobalErrorHandler } from "./globalErrorHandler";


// Initialize global error handler for Axios, JS errors, offline/online events
initGlobalErrorHandler(api);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// Optional: performance reporting
reportWebVitals();
